export default __webpack_public_path__ + "static/media/Gioithieu_thumbnail_3.ed0812cf.png";